import { TextSpan } from '../../../Atoms/Text';
import { SCORE_COLORS, scoreTone, ScoreTone } from './SupplierScoring.calc';

const BADGE_CLASSES = 'inline-flex w-12 justify-center rounded py-1';

const TONE_BACKGROUNDS: Record<ScoreTone, string> = {
  strong: 'bg-green-50',
  caution: 'bg-amber-50',
  unrated: 'bg-grey-1'
};

interface ScoreBadgeProps {
  // Null when nothing is rated, which shows "–" and never 0.
  score: number | null;
  // A category's badge is the average of its rated functions, in blue, with "avg" beneath.
  isAverage?: boolean;
  // Client input, in purple; green and amber stay the user's own rating.
  client?: boolean;
}

export const ScoreBadge = ({ score, isAverage = false, client = false }: ScoreBadgeProps) =>
  isAverage ? (
    <span
      className={`inline-flex w-12 flex-col items-center rounded py-0.5 ${
        client ? (score === null ? 'bg-grey-6' : 'bg-purple-600') : 'bg-main-100'
      }`}>
      <TextSpan
        size="sm"
        weight="semibold"
        color="white"
        className="leading-tight">
        {score ?? '–'}
      </TextSpan>
      <TextSpan
        size="xs"
        color="white"
        className="leading-none">
        avg
      </TextSpan>
    </span>
  ) : client ? (
    <TextSpan
      size="sm"
      weight="semibold"
      color={score === null ? 'grey6' : 'purple'}
      className={`${BADGE_CLASSES} ${score === null ? 'bg-grey-1' : 'bg-purple-50'}`}>
      {score ?? '–'}
    </TextSpan>
  ) : (
    <TextSpan
      size="sm"
      weight="semibold"
      color={SCORE_COLORS[scoreTone(score)]}
      className={`${BADGE_CLASSES} ${TONE_BACKGROUNDS[scoreTone(score)]}`}>
      {score ?? '–'}
    </TextSpan>
  );
